import React from 'react'

import { motion } from 'framer-motion'

const OneLogo = ({ fillColor = 'url(#paint0_linear_6325_18651)', isWhite = false, ...props }) => {
  return (
    <motion.svg
      width="62"
      height="63"
      viewBox="0 0 62 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Original gradient */}
      <motion.g
        animate={{
          opacity: isWhite ? 0 : 1,
        }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      >
        <path
          d="M49.3607 56.2469C44.2373 60.0488 37.8928 62.2999 31.0228 62.2999C24.1528 62.2999 17.8084 60.0501 12.685 56.2469C17.8084 52.4449 24.1516 50.1938 31.0228 50.1938C37.894 50.1938 44.2373 52.4437 49.3607 56.2469Z"
          fill="url(#paint0_linear_6325_18651)"
        />
        <path
          d="M61.8235 31.5008C61.8235 38.3678 59.5746 44.7093 55.776 49.8312C51.9762 44.7093 49.7286 38.3678 49.7286 31.5008C49.7286 24.6338 51.9774 18.2923 55.776 13.1704C59.5759 18.2923 61.8235 24.6338 61.8235 31.5008Z"
          fill="url(#paint1_linear_6325_18651)"
        />
        <path
          d="M6.22817 13.229C10.0011 18.3411 12.2328 24.6594 12.2328 31.5007C12.2328 38.3421 10.0011 44.6604 6.22816 49.7725C2.45523 44.6604 0.223481 38.3421 0.223481 31.5007C0.223482 24.6594 2.45524 18.3411 6.22817 13.229Z"
          fill="url(#paint2_linear_6325_18651)"
        />
        <path
          d="M12.6972 6.74449C17.8183 2.9474 24.1578 0.699948 31.0229 0.699948C37.888 0.699949 44.2276 2.9474 49.3486 6.74449C44.2276 10.5416 37.888 12.789 31.0229 12.789C24.1578 12.789 17.8183 10.5416 12.6972 6.74449Z"
          fill="url(#paint3_linear_6325_18651)"
        />
      </motion.g>

      {/* White version */}
      <motion.g
        animate={{
          opacity: isWhite ? 1 : 0,
        }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path
          d="M49.3607 56.2469C44.2373 60.0488 37.8928 62.2999 31.0228 62.2999C24.1528 62.2999 17.8084 60.0501 12.685 56.2469C17.8084 52.4449 24.1516 50.1938 31.0228 50.1938C37.894 50.1938 44.2373 52.4437 49.3607 56.2469Z"
          fill="#ffffff"
        />
        <path
          d="M61.8235 31.5008C61.8235 38.3678 59.5746 44.7093 55.776 49.8312C51.9762 44.7093 49.7286 38.3678 49.7286 31.5008C49.7286 24.6338 51.9774 18.2923 55.776 13.1704C59.5759 18.2923 61.8235 24.6338 61.8235 31.5008Z"
          fill="#ffffff"
        />
        <path
          d="M6.22817 13.229C10.0011 18.3411 12.2328 24.6594 12.2328 31.5007C12.2328 38.3421 10.0011 44.6604 6.22816 49.7725C2.45523 44.6604 0.223481 38.3421 0.223481 31.5007C0.223482 24.6594 2.45524 18.3411 6.22817 13.229Z"
          fill="#ffffff"
        />
        <path
          d="M12.6972 6.74449C17.8183 2.9474 24.1578 0.699948 31.0229 0.699948C37.888 0.699949 44.2276 2.9474 49.3486 6.74449C44.2276 10.5416 37.888 12.789 31.0229 12.789C24.1578 12.789 17.8183 10.5416 12.6972 6.74449Z"
          fill="#ffffff"
        />
      </motion.g>
      <defs>
        <linearGradient
          id="paint0_linear_6325_18651"
          x1="0.223485"
          y1="31.4999"
          x2="61.8235"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E55619" />
          <stop offset="0.5" stopColor="#E51943" />
          <stop offset="1" stopColor="#A1ADE5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6325_18651"
          x1="0.223485"
          y1="31.4999"
          x2="61.8235"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E55619" />
          <stop offset="0.5" stopColor="#E51943" />
          <stop offset="1" stopColor="#A1ADE5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6325_18651"
          x1="0.223485"
          y1="31.4999"
          x2="61.8235"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E55619" />
          <stop offset="0.5" stopColor="#E51943" />
          <stop offset="1" stopColor="#A1ADE5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6325_18651"
          x1="0.223485"
          y1="31.4999"
          x2="61.8235"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E55619" />
          <stop offset="0.5" stopColor="#E51943" />
          <stop offset="1" stopColor="#A1ADE5" />
        </linearGradient>
      </defs>
    </motion.svg>
  )
}

export default OneLogo
